// Copyright ©️ 2026 eVolve MEP, LLC

import type { UserId } from '@evolvemep/api-ts';

import { strongEntries } from 'helpers/strongEntries';

export const ssoAuthPath = 'login-microsoft-sso';
/** This is the full URL Sso will redirect back to after authentication */
export const ssoRedirectUri = `${window.location.origin}/auth/${ssoAuthPath}/` as const;

export type SsoRedirectState = Partial<{
  previousLoc: typeof window.location.pathname;
  userId: UserId;
  confirmationCode: string;
}>;

export const buildSsoStateVar = (state: SsoRedirectState): string =>
  btoa(
    strongEntries(state)
      .map(([key, val]) => `${key}:${val}`)
      .join(','),
  );

export const extractSsoStateVar = (stateString: string): SsoRedirectState => {
  try {
    return Object.fromEntries(
      atob(stateString)
        .split(',')
        .filter((v) => v.includes(':'))
        .map((v) => v.split(':')),
    ) as SsoRedirectState;
  } catch (e) {
    // oxlint-disable-next-line no-console
    console.error(e);
  }
  return {};
};
